import React, { useEffect } from 'react';

import { useSelector } from 'react-redux';

import {
    AccordionPanel,
} from 'reaxl';
import {
    FilterCheckboxes,
} from 'reaxl-filters';

import getFilterTitle from '@/utilities/getFilterTitle';

import srpFiltersDuck from '@/ducks/srp/srpFiltersDuck.js';

import FilterPlaceholder from './FilterPlaceholder';

/**
*  SellerTypeFilter presents the user with the ability to select a year range
*/
function SellerTypeFilter({
    onOptionChange = () => {},
    onOptionsClear = () => {},
    handleShowExpansion = () => {},
}) {
    const sellerTypeValues = useSelector(srpFiltersDuck.selectors.getSellerTypeValues);
    const sellerTypeOptions = useSelector(srpFiltersDuck.selectors.getSellerTypeOptions);

    const filtersErrors = useSelector(srpFiltersDuck.selectors.getFiltersErrors);
    const filterValues = {
        sellerType: sellerTypeValues,
    };

    const filterName = 'sellerType';
    const isExpanded = useSelector((state) => srpFiltersDuck.selectors.isExpansionActive(state, filterName));
    const showFilter = isExpanded && Object.keys(sellerTypeOptions).length !== 0;

    // expand the panel if active options inside of it
    useEffect(() => {
        if (sellerTypeValues.length) {
            handleShowExpansion(filterName);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [sellerTypeValues.length]);

    const title = getFilterTitle('Seller Type', sellerTypeValues);

    return (
        <AccordionPanel
            eventKey={filterName}
            data-cmp="SellerTypeFilter"
            title={title}
            contentPadding={5}
        >
            { !showFilter && <FilterPlaceholder uniqueKey={filterName} /> }
            { showFilter && (
                <FilterCheckboxes
                    key="filterCheckboxes"
                    filter={sellerTypeOptions}
                    onOptionChange={onOptionChange}
                    onOptionsClear={onOptionsClear}
                    values={filterValues}
                    errors={filtersErrors}
                    withAccordion={false}
                />
            )}
        </AccordionPanel>
    );

}

export default SellerTypeFilter;
